import {STORE_CONTRACTOR_NON_ENGINEER_REQUEST, STORE_CONTRACTOR_NON_ENGINEER_SUCCESS, STORE_CONTRACTOR_NON_ENGINEER_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST, UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS, UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE} from '../actions';
import {
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS,
    CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE
} from '../actions';

export const CONTRACTOR_NON_ENGINEER_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    full_name: '',
    email: '',
    phone_number: '',
    job_title: '',
    crb_expiry_date: null,
    working_at_heights: null,
    manual_handling: null,
    asbestos_cat_b: null,
    ppe: null,
    isUploading: false,
    isRemoving: false,
    uploadError: null,
    removeError: null,
    documents: []
};

const nonEngineerReducers = {
    [STORE_CONTRACTOR_NON_ENGINEER_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null, draft: true};
    },
    [STORE_CONTRACTOR_NON_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null, draft: false}
    },
    [STORE_CONTRACTOR_NON_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_CONTRACTOR_NON_ENGINEER_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [UPDATE_CONTRACTOR_NON_ENGINEER_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_CONTRACTOR_NON_ENGINEER_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_REQUEST]: (state) => {
        return {...state, isUploading: true, uploadError: null};
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isUploading: false, uploadError: null};
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isUploading: false, uploadError: error};
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_REQUEST]: (state) => {
        return {...state, isRemoving: true, removeError: null};
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);

        return {...state, documents, isRemoving: false, removeError: null}
    },
    [CONTRACTOR_NON_ENGINEER_DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isRemoving: false, removeError: error};
    }
};

export default function admin(state = CONTRACTOR_NON_ENGINEER_INITIAL_STATE, action) {
    let reducer = nonEngineerReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-non-engineer.js